import { registerHandler } from '../MessageManager';

export function registerDebugSplashScreen(): void {
    const div: HTMLDivElement = document.createElement('div');
    div.style.position = 'fixed';
    div.style.zIndex = '9999';
    div.style.left = '0';
    div.style.bottom = '0';
    div.style.backgroundColor = '#f00';
    div.style.opacity = '0.5';
    div.style.width = '100%';
    div.style.height = '100%';

    document.body.appendChild(div);

    registerHandler({
        type: 'initialization',
        callback: (event: MessageEvent): void => {
            switch (event.data.action) {
                case 'finished':
                    if (document.body.contains(div)) {
                        document.body.removeChild(div);
                    }
                    break;
                case 'started':
                    if (!document.body.contains(div)) {
                        document.body.appendChild(div);
                    }
                    break;
                default:
                    break;
            }
        }
    });
}